var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSkipLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14286 0.957482C9.44248 1.24349 9.45352 1.71823 9.16751 2.01786L4.57661 6.82738C4.48439 6.92399 4.48439 7.07601 4.57661 7.17262L9.16752 11.9821C9.45352 12.2818 9.44248 12.7565 9.14286 13.0425C8.84323 13.3285 8.36849 13.3175 8.08248 13.0179L3.49157 8.20833C2.84607 7.53209 2.84607 6.46791 3.49157 5.79167L8.08248 0.982142C8.36849 0.682519 8.84323 0.671478 9.14286 0.957482Z",
    fill: "#80959D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.25C1.5 12.6642 1.16421 13 0.75 13C0.335787 13 0 12.6642 0 12.25L0 1.75C0 1.33579 0.335787 1 0.75 1C1.16421 1 1.5 1.33579 1.5 1.75L1.5 12.25Z",
    fill: "#80959D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkipLeftArrow);
export default __webpack_public_path__ + "static/media/icon-skip-left-arrow.e0e0fe7a1987b88268a45323f1874f2e.svg";
export { ForwardRef as ReactComponent };